import React from 'react';
import { Wrench, Phone, ShieldCheck, CheckCircle2 } from 'lucide-react';
const PHONE = '586-203-3701';
export function Hero() {
  return <section id="top" className="relative bg-[#1a2332] overflow-hidden" data-id="element-88">
      {/* Background: real shingle roof close-up */}
      <div className="absolute inset-0" data-id="element-89">
        <img src="https://images.unsplash.com/photo-1632759145355-8b8f3f5e6a7e?w=1600&q=80&auto=format&fit=crop" alt="" aria-hidden="true" className="w-full h-full object-cover opacity-40" onError={e => {
        ;
        (e.currentTarget as HTMLImageElement).src = 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=1600&q=80&auto=format&fit=crop';
      }} data-id="element-90" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a2332]/85 via-[#1a2332]/70 to-[#1a2332]/95" data-id="element-91" />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36 text-center text-white" data-id="element-92">
        {/* Small brand label */}
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-93">
          <Wrench className="w-5 h-5 text-[#2DB8E0]" data-id="element-94" />
          <span className="font-semibold text-white/90 tracking-wide" data-id="element-95">
            Moceri Residential Services LLC
          </span>
        </div>

        {/* Headline — elegant serif italic matching brand site */}
        <h1 className="font-display italic font-medium text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight mb-4 text-white" data-id="element-96">
          Michigan's Trusted Shingle Roof Replacement Experts
        </h1>

        {/* Decorative underline */}
        <div className="w-32 h-px bg-white/40 mx-auto mb-8" data-id="element-97" />

        {/* Subheadline */}
        <p className="text-lg sm:text-xl text-white/85 leading-relaxed max-w-3xl mx-auto mb-6" data-id="element-98">
          At Moceri Residential Services, we believe in delivering more than
          just a service — we deliver peace of mind. Say goodbye to missed
          appointments and fluctuating prices. We offer upfront, competitive
          pricing and always show up when we say we will.
        </p>

        <p className="text-base sm:text-lg text-white/75 max-w-2xl mx-auto mb-10" data-id="element-99">
          Whether your roof is storm-damaged, aging, or simply due for a full
          replacement, our Michigan crew delivers premium architectural shingles
          built for harsh winters and everything in between.
        </p>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 mb-10 text-sm sm:text-base" data-id="element-100">
          <div className="flex items-center gap-2" data-id="element-101">
            <CheckCircle2 className="w-5 h-5 text-[#2DB8E0]" data-id="element-102" />
            <span className="font-medium text-white/90" data-id="element-103">
              Licensed & Insured
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-104">
            <CheckCircle2 className="w-5 h-5 text-[#2DB8E0]" data-id="element-105" />
            <span className="font-medium text-white/90" data-id="element-106">Upfront Pricing</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-107">
            <CheckCircle2 className="w-5 h-5 text-[#2DB8E0]" data-id="element-108" />
            <span className="font-medium text-white/90" data-id="element-109">
              Built for Michigan Winters
            </span>
          </div>
        </div>

        {/* Dual CTAs */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-110">
          <a href="#quote-form" className="inline-flex items-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold text-lg px-8 py-4 rounded-full transition-all shadow-lg hover:shadow-xl" data-id="element-111">
            <span className="mr-2" data-id="element-112">—</span>
            Get a Quote Now!
            <span className="ml-2" data-id="element-113">—</span>
          </a>
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 text-white hover:text-[#2DB8E0] font-bold text-lg px-6 py-4 transition-colors" data-id="element-114">
            <Phone className="w-5 h-5" data-id="element-115" />
            {PHONE}
          </a>
        </div>

        {/* Coupon callout */}
        <div className="mt-10 inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-[#2DB8E0]/40 rounded-full px-5 py-2.5" data-id="element-116">
          <ShieldCheck className="w-5 h-5 text-[#2DB8E0]" data-id="element-117" />
          <span className="font-bold text-sm sm:text-base" data-id="element-118">
            <span className="text-[#2DB8E0]" data-id="element-119">$500 OFF</span> when you book this
            month
          </span>
        </div>
      </div>
    </section>;
}